/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisibilityConditionOperator } from './VisibilityConditionOperator';
import {
    VisibilityConditionOperatorFromJSON,
    VisibilityConditionOperatorFromJSONTyped,
    VisibilityConditionOperatorToJSON,
    VisibilityConditionOperatorToJSONTyped,
} from './VisibilityConditionOperator';
import type { VisibilityConditionType } from './VisibilityConditionType';
import {
    VisibilityConditionTypeFromJSON,
    VisibilityConditionTypeFromJSONTyped,
    VisibilityConditionTypeToJSON,
    VisibilityConditionTypeToJSONTyped,
} from './VisibilityConditionType';

/**
 * A visibility condition node - either a leaf (single condition) or a group (AND/OR of conditions). Use nodeType to determine which properties are relevant.
 * @export
 * @interface VisibilityConditionNode
 */
export interface VisibilityConditionNode {
    /**
     * Type discriminator - LEAF for single condition, GROUP for AND/OR of conditions
     * @type {string}
     * @memberof VisibilityConditionNode
     */
    nodeType?: VisibilityConditionNodeNodeTypeEnum;
    /**
     * 
     * @type {VisibilityConditionType}
     * @memberof VisibilityConditionNode
     */
    formElementConditionType?: VisibilityConditionType;
    /**
     * [LEAF] Reference key of the source form element to check
     * @type {string}
     * @memberof VisibilityConditionNode
     */
    sourceFormElementReference?: string | null;
    /**
     * [LEAF] When the source form element is a TABLE, the column index whose cell values are aggregated (joined to a comma string) before applying the operator. Ignored for non-TABLE sources.
     * @type {number}
     * @memberof VisibilityConditionNode
     */
    sourceTableColumnIndex?: number | null;
    /**
     * [LEAF] Expected value to compare against the source element's value
     * @type {string}
     * @memberof VisibilityConditionNode
     */
    formElementExpectedValue?: string | null;
    /**
     * 
     * @type {VisibilityConditionOperator}
     * @memberof VisibilityConditionNode
     */
    formElementOperator?: VisibilityConditionOperator;
    /**
     * [GROUP] Logical operator to combine conditions
     * @type {string}
     * @memberof VisibilityConditionNode
     */
    groupOperator?: VisibilityConditionNodeGroupOperatorEnum | null;
    /**
     * [GROUP] List of child conditions
     * @type {Array<VisibilityConditionNode>}
     * @memberof VisibilityConditionNode
     */
    conditions?: Array<VisibilityConditionNode> | null;
}


/**
 * @export
 */
export const VisibilityConditionNodeNodeTypeEnum = {
    Leaf: 'LEAF',
    Group: 'GROUP'
} as const;
export type VisibilityConditionNodeNodeTypeEnum = typeof VisibilityConditionNodeNodeTypeEnum[keyof typeof VisibilityConditionNodeNodeTypeEnum];

/**
 * @export
 */
export const VisibilityConditionNodeGroupOperatorEnum = {
    And: 'AND',
    Or: 'OR'
} as const;
export type VisibilityConditionNodeGroupOperatorEnum = typeof VisibilityConditionNodeGroupOperatorEnum[keyof typeof VisibilityConditionNodeGroupOperatorEnum];


/**
 * Check if a given object implements the VisibilityConditionNode interface.
 */
export function instanceOfVisibilityConditionNode(value: object): value is VisibilityConditionNode {
    return true;
}

export function VisibilityConditionNodeFromJSON(json: any): VisibilityConditionNode {
    return VisibilityConditionNodeFromJSONTyped(json, false);
}

export function VisibilityConditionNodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisibilityConditionNode {
    if (json == null) {
        return json;
    }
    return {
        
        'nodeType': json['nodeType'] == null ? undefined : json['nodeType'],
        'formElementConditionType': json['formElementConditionType'] == null ? undefined : VisibilityConditionTypeFromJSON(json['formElementConditionType']),
        'sourceFormElementReference': json['sourceFormElementReference'] == null ? undefined : json['sourceFormElementReference'],
        'sourceTableColumnIndex': json['sourceTableColumnIndex'] == null ? undefined : json['sourceTableColumnIndex'],
        'formElementExpectedValue': json['formElementExpectedValue'] == null ? undefined : json['formElementExpectedValue'],
        'formElementOperator': json['formElementOperator'] == null ? undefined : VisibilityConditionOperatorFromJSON(json['formElementOperator']),
        'groupOperator': json['groupOperator'] == null ? undefined : json['groupOperator'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(VisibilityConditionNodeFromJSON)),
    };
}

export function VisibilityConditionNodeToJSON(json: any): VisibilityConditionNode {
    return VisibilityConditionNodeToJSONTyped(json, false);
}

export function VisibilityConditionNodeToJSONTyped(value?: VisibilityConditionNode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nodeType': value['nodeType'],
        'formElementConditionType': VisibilityConditionTypeToJSON(value['formElementConditionType']),
        'sourceFormElementReference': value['sourceFormElementReference'],
        'sourceTableColumnIndex': value['sourceTableColumnIndex'],
        'formElementExpectedValue': value['formElementExpectedValue'],
        'formElementOperator': VisibilityConditionOperatorToJSON(value['formElementOperator']),
        'groupOperator': value['groupOperator'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(VisibilityConditionNodeToJSON)),
    };
}

